import { render, staticRenderFns } from "./AutoReminderSetField.vue?vue&type=template&id=416957b4"
import script from "./AutoReminderSetField.vue?vue&type=script&lang=js"
export * from "./AutoReminderSetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports